import errorActions from "./errorActions";

export default errorActions;
